import OrderPayout from "../../services/api/OrderPayout";
import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import ErrorMsgs from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import orderPayoutService from "../../services/api/OrderPayout";

const handleError = (err) => {
  console.log("[handleError] Error in OrderPayout actions", err);
};

export const setOrderDetails = (payload) => {
  return {
    type: ActionTypes.SET_ORDER_DETAILS,
    payload: payload,
  };
};

export const getOrderDetails =
  (FilterType, FilterValue, BusinessType) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let queryParam = `business_type=${BusinessType}&filter_type=${FilterType}&filter_value=${FilterValue}`;
      const response = await orderPayoutService.GetOrderDetails(queryParam);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setOrderDetails(response));
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };
